module.exports = __webpack_public_path__ + "static/img/ocean-poster.057cef9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ocean-poster.jpg
// module id = ZI6r
// module chunks = 1